import { render, staticRenderFns } from "./TransferPickupSuccessModal.vue?vue&type=template&id=2cadebc4&scoped=true&"
import script from "./TransferPickupSuccessModal.vue?vue&type=script&lang=ts&"
export * from "./TransferPickupSuccessModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferPickupSuccessModal.vue?vue&type=style&index=0&id=2cadebc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadebc4",
  null
  
)

export default component.exports